import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IDeclaration } from '../interfaces';
import { DeclarationMapper } from '../mappers';

export type IGetDeclarationByIdRepoResponse = IRepoResponse<200, IDeclaration> | IRepoResponse<400 | 500, string>;

export type IGetDeclarationByIdRepo = IRepo<[number | string], IGetDeclarationByIdRepoResponse>;

export const GetDeclarationByIdRepoType = Symbol.for('GetDeclarationByIdRepo');

@bind(GetDeclarationByIdRepoType)
export class GetDeclarationByIdRepo implements IGetDeclarationByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/declaration/info', { declaration_id: id }) });
      if (result.status === 200) {
        const data: IDeclaration = DeclarationMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
